var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationSitemap = void 0;

var react_1 = __importStar(require("react"));

var core_1 = require("@wheelroom/core");

var navigation_segment_1 = require("../../navigation-segment/navigation-segment");

var get_nav_segments_1 = require("../../navigation/get-nav-segments");

exports.NavigationSitemap = function (props) {
  if (!Array.isArray(props.navigation) || props.navigation.length < 1) {
    return null;
  }

  var ContainerType = props.containerStyle === 'container' ? core_1.Container : core_1.Fluid;
  var menuSegments = get_nav_segments_1.getNavSegments(props.navigation, 'menu');
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(core_1.Wrapper, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.wrapper
    })
  }, react_1.default.createElement(ContainerType, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.container
    })
  }, react_1.default.createElement(core_1.Flex, {
    is: "div",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.sitemap
    })
  }, !props.data.hideMenu && react_1.default.createElement(core_1.Flex, {
    is: 'nav',
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.sitemap.menu
    })
  }, react_1.default.createElement(navigation_segment_1.NavigationSegment, {
    headingElementName: props.data.headingElementName || 'h3',
    hideActionHeading: false,
    hideActionIcon: false,
    hideSegmentAbstract: true,
    hideSegmentHeading: props.data.hideSegmentHeading,
    maxSegments: props.data.maxSegments || 16,
    navigationSegment: menuSegments,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.sitemap.menu.segment
    })
  }))))));
};